import React from "react";
import Page from "components/common_components/Page/Page";

const Home = () => {
    return (
        <Page>
            Colors
            {["primary", "secondary", "third", "grey", "extra"].map((color) => (
                <div
                    style={{
                        width: "100%",
                        minHeight: 50,
                        marginBottom: 20,
                        padding: 10,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    className={`bg--${color}`}
                >
                    {color.toUpperCase()}
                </div>
            ))}
        </Page>
    );
};

export default Home;
